// Safe JSON access to localStorage.
//
// JSON.parse(localStorage.getItem(key)) breaks when the stored value is not
// valid JSON. The most common case is the literal string "undefined": if we
// write JSON.stringify(x) with x === undefined, JSON.stringify returns the
// value undefined and localStorage.setItem coerces it to the string
// "undefined", which then throws '"undefined" is not valid JSON' on every
// later read. Storage can also be unavailable (Safari private mode, blocked
// cookies) or hold data written by an older version of the app.
//
// Use getJSON/setJSON instead of reading and writing localStorage directly for
// any value that is stored as JSON.

// Returns the parsed value, or fallback (default null) if the key is missing,
// unreadable or corrupted. A corrupted entry is removed so it stops failing.
export const getJSON = (key, fallback = null) => {
  let raw = null;
  try {
    raw = localStorage.getItem(key);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`localStorage no disponible al leer "${key}"`, e);
    return fallback;
  }

  if (raw === null || raw === '' || raw === 'undefined') {
    return fallback;
  }

  try {
    const parsed = JSON.parse(raw);
    return parsed === null || typeof parsed === 'undefined' ? fallback : parsed;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Valor inválido en localStorage["${key}"], se descarta`, e);
    try {
      localStorage.removeItem(key);
    } catch (removeError) {
      // ignore
    }
    return fallback;
  }
};

// Stores value as JSON. Never writes the string "undefined": an undefined value
// removes the key instead. Returns true when the write succeeded.
export const setJSON = (key, value) => {
  try {
    if (typeof value === 'undefined') {
      localStorage.removeItem(key);
      return false;
    }
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`No se pudo escribir localStorage["${key}"]`, e);
    return false;
  }
};

export default { getJSON, setJSON };
